import { useState, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { useLocation } from 'react-router-dom';

import { getChannel } from '../../graphql/query';
import { Channel } from '../../types/ChannelType';
import Storage, { StorageKeys } from '../../helpers/Storage';
import { useWorkplaceOnboardingEnabled } from './useWorkplaceOnboardingEnabled';

import { ActiveChannelTypeEnum } from 'constants-channel';

export function usePublicProfileChannel():
  | {
      channel: Channel;
      isBuilding: boolean;
      isCompany: boolean;
    }
  | undefined {
  const location = useLocation();
  const isWorkplaceOnboardingEnabled = useWorkplaceOnboardingEnabled();
  const [onboardingChannelId, setOnboardingChannelId] = useState<string | null>(
    null
  );
  const searchParamsChannelId = new URLSearchParams(location.search).get(
    'channelId'
  );

  useEffect(() => {
    const handleChannelId = async () => {
      if (!isWorkplaceOnboardingEnabled) {
        return;
      }

      if (searchParamsChannelId) {
        await Storage.setItem(
          StorageKeys.ONBOARDING_CHANNEL_ID,
          searchParamsChannelId
        );
      } else {
        const storedOnboardingId = await Storage.getItemMaybe(
          StorageKeys.ONBOARDING_CHANNEL_ID
        );

        if (storedOnboardingId && typeof storedOnboardingId === 'string') {
          setOnboardingChannelId(storedOnboardingId);
        }
      }
    };

    handleChannelId();
  }, [searchParamsChannelId, isWorkplaceOnboardingEnabled]);

  const publicProfileChannelId = searchParamsChannelId ?? onboardingChannelId;

  const { data: publicProfileChannel } = useQuery(getChannel, {
    variables: { id: publicProfileChannelId },
    skip: !publicProfileChannelId,
  });

  if (!publicProfileChannel?.channel) {
    return undefined;
  }

  const isPublicProfileBuilding =
    publicProfileChannel.channel.type === ActiveChannelTypeEnum.Property;

  return {
    channel: publicProfileChannel.channel,
    isBuilding: isPublicProfileBuilding,
    isCompany: !isPublicProfileBuilding,
  };
}
